@media (prefers-color-scheme: dark) {
  :root[data-color-mode="system"] {
    --add-ons-interaction-30: hsl(204, 95%, 75%);
    --add-ons-interaction-40: hsl(204, 95%, 65%);
    --add-ons-interaction-50: hsl(204, 100%, 45%); /* base */
    --add-ons-interaction-60: hsl(204, 100%, 40%);
    --add-ons-interaction-70: hsl(204, 100%, 25%);
    --add-ons-interaction-80: hsl(206, 32%, 16%);
    --add-ons-interaction-90: hsl(204, 22%, 14%);

    --add-ons-success-30: hsl(97, 53%, 55%);
    --add-ons-success-40: hsl(97, 53%, 43%);
    --add-ons-success-50: hsl(97, 57%, 38%); /* base */
    --add-ons-success-60: hsl(97, 57%, 33%);
    --add-ons-success-70: hsl(97, 57%, 18%);
    --add-ons-success-80: hsl(125, 17%, 15%);
    --add-ons-success-90: hsl(120, 12%, 14%);

    --add-ons-warning-30: hsl(42, 80%, 57%);
    --add-ons-warning-40: hsl(42, 80%, 50%);
    --add-ons-warning-50: hsl(42, 84%, 43%); /* base */
    --add-ons-warning-60: hsl(42, 84%, 35%);
    --add-ons-warning-70: hsl(42, 84%, 24%);
    --add-ons-warning-80: hsl(41, 18%, 17%);
    --add-ons-warning-90: hsl(42, 13%, 15%);

    --add-ons-danger-30: hsl(8, 56%, 60%);
    --add-ons-danger-40: hsl(8, 56%, 52%);
    --add-ons-danger-50: hsl(8, 60%, 45%); /* base */
    --add-ons-danger-60: hsl(8, 60%, 40%);
    --add-ons-danger-70: hsl(9, 60%, 25%);
    --add-ons-danger-80: hsl(8, 20%, 16%);
    --add-ons-danger-90: hsl(10, 16%, 14%);

    --add-ons-legacy-brand-25: hsl(218, 84%, 25%);

    --add-ons-legacy-brand-62: hsl(221, 91%, 67%);
    --add-ons-legacy-brand-87: hsl(221, 91%, 52%);

    --add-ons-legacy-create-23: hsl(86 91% 40%);
    --add-ons-legacy-create-25: hsl(86 91% 32%);
    --add-ons-legacy-create-27: hsl(86 91% 30%);
    --add-ons-legacy-create-35: hsl(86 91% 28%);
    --add-ons-legacy-create-91: hsl(125, 17%, 15%);
    --add-ons-legacy-create-97: hsl(120, 12%, 14%);

    --add-ons-legacy-delete-47: hsl(8, 60%, 45%);
    --add-ons-legacy-delete-45: hsl(8, 60%, 40%);
    --add-ons-legacy-delete-43: hsl(9, 60%, 35%);
    --add-ons-legacy-delete-93: hsl(8, 20%, 16%);
    --add-ons-legacy-delete-97: hsl(10, 16%, 15%);

    --add-ons-legacy-warning-49: hsl(42, 80%, 57%);
    --add-ons-legacy-warning-55: hsl(42, 84%, 43%);
    --add-ons-legacy-warning-63: hsl(42, 84%, 35%);
    --add-ons-legacy-warning-90: hsl(42, 84%, 29%);
    --add-ons-legacy-warning-94: hsl(41, 18%, 17%);
    --add-ons-legacy-warning-97: hsl(42, 13%, 15%);
    --add-ons-legacy-warning-text: hsl(36, 100%, 61%);

    --add-ons-naked-input-background: var(--t-form-background-color);
  }
}
